/**
 * Created by eriksundqvist on 25/05/16.
 */
import { connect } from 'react-redux';
import {
          setUserId,
          setTaxId,
          setSaveVacationPay,
          setAmount,
          setCustomerId,
          setCurrencyId,
          setCurrencyName,
          setCurrencyAmount,
          setSpecification,
          setInvoiceDate,
          setInvoiceUser,
          setInvoiceId,
          setSupplierLedger,
          setSendToEmail,
          setSendToEmailSecondary,
          setSendToEmailBool,
          setEinvoiceAddress,
          setValid,
          setPosting,
          setPostError,
          clear,
          setLockAmountDistribution,
          setInitializing,
          setRut,
          setRot,
          setDisplayDates,
          setDisplayHours,
          setSubmitted,
          setPreReport,
          setPreReportedAt,
          setTermsAccepted,
          setExpressPayment,
          setCouponId,
          setMessageType,
          setSurveyAnswers
        } from 'redux/modules/invoice/index';
import InvoiceTool from './invoice-tool';
import {setValidationErrors, clearValidationErrors} from 'redux/modules/validation-errors/index';
import { setSupplierLedgerTypes } from 'redux/modules/supplier-ledger-types/index';

function mapStateToProps (state) {
  return {
    user: state.user,
    taxkeys: state.taxkeys,
    invoice: state.invoice,
    currencies: state.currencies
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUserId: (userId) => dispatch(setUserId(userId)),
    setTaxId: (taxId) => dispatch(setTaxId(taxId)),
    setSaveVacationPay: (saveVacationPay) => dispatch(setSaveVacationPay(saveVacationPay)),
    setAmount: (amount) => dispatch(setAmount(amount)),
    setCustomerId: (customerId) => dispatch(setCustomerId(customerId)),
    setCurrencyId: (currencyId) => dispatch(setCurrencyId(currencyId)),
    setCurrencyName: (currencyName) => dispatch(setCurrencyName(currencyName)),
    setCurrencyAmount: (currencyAmount) => dispatch(setCurrencyAmount(currencyAmount)),
    setSpecification: (specification) => dispatch(setSpecification(specification)),
    setInvoiceDate: (date) => dispatch(setInvoiceDate(date)),
    setInvoiceUser: (invoiceUser) => dispatch(setInvoiceUser(invoiceUser)),
    setInvoiceId: (invoiceId) => dispatch(setInvoiceId(invoiceId)),
    setSupplierLedger: (supplierLedger) => dispatch(setSupplierLedger(supplierLedger)),
    setValid: (valid) => dispatch(setValid(valid)),
    setPosting: (posting) => dispatch(setPosting(posting)),
    setPostError: (postError) => dispatch(setPostError(postError)),
    setValidationErrors: (validationError) => dispatch(setValidationErrors(validationError)),
    clearValidationErrors: () => dispatch(clearValidationErrors()),
    clear: () => dispatch(clear()),
    setLockAmountDistribution: (lockAmountDistribution) => dispatch(setLockAmountDistribution(lockAmountDistribution)),
    setInitializing: (initializing) => dispatch(setInitializing(initializing)),
    setRut: (rut) => dispatch(setRut(rut)),
    setRot: (rot, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType) =>
      dispatch(setRot(rot, data, apartmentNumber, cooperativeApartmentRegistrationNumber, accommodationType)),
    setSendToEmail: (sendToEmail) => dispatch(setSendToEmail(sendToEmail)),
    setSendToEmailSecondary: (sendToEmail) => dispatch(setSendToEmailSecondary(sendToEmail)),
    setSendToEmailBool: (sendToEmail) => dispatch(setSendToEmailBool(sendToEmail)),
    setEinvoiceAddress: (einvoiceAddress) => dispatch(setEinvoiceAddress(einvoiceAddress)),
    setDisplayDates: (displayDates) => dispatch(setDisplayDates(displayDates)),
    setDisplayHours: (displayHours) => dispatch(setDisplayHours(displayHours)),
    setSubmitted: (submitted) => dispatch(setSubmitted(submitted)),
    setPreReport: (preReport) => dispatch(setPreReport(preReport)),
    setPreReportedAt: (preReportedAt) => dispatch(setPreReportedAt(preReportedAt)),
    setTermsAccepted: (termsAccepted) => dispatch(setTermsAccepted(termsAccepted)),
    setExpressPayment: (expressPayment) => dispatch(setExpressPayment(expressPayment)),
    setSupplierLedgerTypes: (types) => dispatch(setSupplierLedgerTypes(types)),
    setCouponId: (couponId) => dispatch(setCouponId(couponId)),
    setMessageType: (messageType) => dispatch(setMessageType(messageType)),
    setSurveyAnswers: (answers, status) => dispatch(setSurveyAnswers(answers, status))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceTool);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/invoice-tool-container.js
 **/